import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

export default makeStyles((theme) => ({
  Review: {
    marginBottom:15,
    marginTop:15,
    padding: '0px 15px 0px 15px',
  },
  Rating: {
    display: 'inline-flex',
    marginBottom: 0,
  },
}));
